import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-white rounded-2xl shadow-md mt-10 text-gray-800">
      <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
      <p className="mb-4">
        Welcome to <strong>BOG Gems</strong> – your trusted destination for
        authentic Rudraksha and spiritual jewelry. This Privacy Policy outlines
        how we collect, use, disclose, and protect your information when you use
        our mobile application and website, in compliance with Google Play Store
        requirements.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        1. Information We Collect
      </h2>
      <ul className="list-disc list-inside space-y-1 mb-4">
        <li>
          <strong>Personal Information:</strong> Name, phone number, email, and
          shipping address for order processing and customer support.
        </li>
        <li>
          <strong>Location Information:</strong> With your permission, we
          collect location data to provide location-based services, such as
          optimizing delivery routes and offering region-specific promotions.
        </li>
        <li>
          <strong>Non-Personal Information:</strong> Device information (e.g.,
          device type, OS version) and app usage data for improving app
          performance and analytics.
        </li>
        <li>
          We do not currently collect or store payment information as we only
          accept Cash on Delivery (COD).
        </li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        2. How We Use Your Information
      </h2>
      <p className="mb-4">We use your information to:</p>
      <ul className="list-disc list-inside space-y-1 mb-4">
        <li>Process and deliver your orders and provide customer support.</li>
        <li>
          Use location data to optimize delivery, provide location-specific
          offers, and improve user experience (with your consent).
        </li>
        <li>
          Send order updates, promotions, and notifications (with your explicit
          consent, where required).
        </li>
        <li>
          Analyze app usage to improve our services, app functionality, and user
          experience.
        </li>
        <li>Comply with legal obligations and prevent fraud or misuse.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        3. Cash on Delivery (COD)
      </h2>
      <p className="mb-4">
        We currently offer Cash on Delivery as the only payment method. No
        sensitive payment information is collected or stored.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        4. Future Payment Integrations
      </h2>
      <p className="mb-4">
        If we introduce third-party payment gateways in the future, we will use
        secure, industry-standard methods to process payments. Your payment data
        will be handled in compliance with applicable data protection laws, and
        this policy will be updated accordingly.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        5. Third-Party Services
      </h2>
      <p className="mb-4">
        We may use third-party services (e.g., Firebase, Google Analytics) to
        enhance app functionality and performance. These services may collect
        anonymized data, such as usage statistics, to help us improve your
        experience. Please refer to their respective privacy policies for
        details.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">6. Data Sharing</h2>
      <p className="mb-4">
        We do not sell, trade, or rent your personal information to third
        parties. We may share your information with:
      </p>
      <ul className="list-disc list-inside space-y-1 mb-4">
        <li>
          Trusted service providers (e.g., delivery partners) to fulfill orders.
        </li>
        <li>
          Legal authorities when required to comply with applicable laws or
          protect our rights.
        </li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">7. Data Security</h2>
      <p className="mb-4">
        We implement industry-standard technical and organizational measures
        (e.g., encryption, access controls) to protect your personal information
        from unauthorized access, disclosure, alteration, or loss. However, no
        method of transmission over the internet is 100% secure.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">8. Your Rights</h2>
      <p className="mb-4">
        Depending on your jurisdiction, you may have the right to:
      </p>
      <ul className="list-disc list-inside space-y-1 mb-4">
        <li>Access, correct, or delete your personal information.</li>
        <li>
          Opt out of promotional communications or location data collection.
        </li>
        <li>Request data portability or restrict data processing.</li>
      </ul>
      <p className="mb-4">
        To exercise these rights, contact us at the details provided below.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">9. Data Retention</h2>
      <p className="mb-4">
        We retain your personal information only for as long as necessary to
        fulfill the purposes outlined in this policy or as required by law.
        Non-personal data may be retained indefinitely for analytics purposes.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        10. Children's Privacy
      </h2>
      <p className="mb-4">
        Our app is not intended for users under 13 years of age. We do not
        knowingly collect personal information from children under 13. If we
        become aware of such data, we will take steps to delete it.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">11. Your Consent</h2>
      <p className="mb-4">
        By using our app or website, you consent to the collection and use of
        your information as described in this Privacy Policy.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        12. Changes to This Policy
      </h2>
      <p className="mb-4">
        We may update this Privacy Policy to reflect changes in our practices or
        legal requirements. Significant changes will be communicated via the
        app, website, or email. Please review this policy periodically.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">13. Contact Us</h2>
      <p className="mb-4">
        For questions, concerns, or to exercise your data rights, contact us at:
        <br />
        <strong>Email:</strong>BOG bombay365gems@gmail.com
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
      </p>
    </div>
  );
};

export default PrivacyPolicy;
